import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('VisitIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__visit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.36 22.54">
        <path className="foreground" d="M22.43,1.41a2.11,2.11,0,0,0-2-1.41H4.93a2.11,2.11,0,0,0-2,1.41L0,9.86V21.13a1.41,1.41,0,0,0,1.41,1.41H2.82a1.41,1.41,0,0,0,1.41-1.41h0V19.72h16.9v1.41a1.41,1.41,0,0,0,1.41,1.41h1.41a1.41,1.41,0,0,0,1.41-1.41h0V9.86ZM4.93,15.5A2.11,2.11,0,1,1,7,13.39H7A2.11,2.11,0,0,1,4.93,15.5Zm15.5,0a2.11,2.11,0,1,1,2.11-2.11h0a2.11,2.11,0,0,1-2.11,2.11h0Zm-17.61-7L4.93,2.11h15.5l2.11,6.34Z"/>
      </svg>
    ), el);
  });
};
